import React from 'react';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';
import ServicePageLayout from './ServicePageLayout';
import { fadeInUp } from '../constants/animations';

function BusinessPhone() {
  return (
    <ServicePageLayout
      title="Business Phone Line"
      subtitle="Give your business a professional line with smart routing, tracking, and an auto‑attendant."
    >
      <div className="service-section">
        <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={0}>
          <h4>Professional caller experience</h4>
          <p>Branded greetings and clean call flows for a premium first impression.</p>
        </motion.div>
        <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={1}>
          <h4>Call routing</h4>
          <p>Route calls to the right person or team instantly.</p>
        </motion.div>
        <motion.div className="service-feature" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={2}>
          <h4>Call logs</h4>
          <p>Track every call and see lead volume in one place.</p>
        </motion.div>
      </div>

      <motion.div className="service-block" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.25 }} variants={fadeInUp} custom={0}>
        <h3>What you get</h3>
        <ul className="service-list">
          <li>VOIP system with auto‑attendant</li>
          <li>Press‑to‑route menus for teams</li>
          <li>Call tracking and reporting</li>
          <li>Professional business line setup</li>
        </ul>
      </motion.div>

      <div className="service-split">
        <motion.div className="service-split-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={0}>
          <h4>Who it’s for</h4>
          <p>Businesses that want to sound bigger and never miss calls.</p>
        </motion.div>
        <motion.div className="service-split-card" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.2 }} variants={fadeInUp} custom={1}>
          <h4>Pairs with AI</h4>
          <p>Add AI call handling for missed calls and lead capture.</p>
        </motion.div>
      </div>

      <motion.div className="service-cta" initial="hidden" whileInView="visible" viewport={{ once: true, amount: 0.35 }} variants={fadeInUp} custom={0}>
        <Link to="/plans">Get Started</Link>
      </motion.div>
    </ServicePageLayout>
  );
}

export default BusinessPhone;
